import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { softwareClassicProformaIssueFormsDirectRoute } from '@atlassian/jira-router-routes-classic-projects-routes/src/softwareClassicProformaIssueFormsDirectRoute.tsx';
import { classicSoftwareProjectLayoutNoOnboarding } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { proformaIssueFormsDirectPageEntryPoint } from './ui/proforma/issue-forms-direct/index.tsx';

export const softwareClassicProformaIssueFormsDirectRouteEntry = createEntry(
	softwareClassicProformaIssueFormsDirectRoute,
	() => ({
		group: 'classic-software',
		layout: classicSoftwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MENU_ID.PROJECTS,
		},

		resources: [projectContextResource],
		entryPoint: () => proformaIssueFormsDirectPageEntryPoint,
		perfMetricKey: 'issue-forms-direct',

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-classic-projects-entries/src/softwareClassicProformaIssueFormsDirectRouteEntry.tsx',
				whichExportToUse: 'softwareClassicProformaIssueFormsDirectRouteEntry',
			},

			enabled: true,
		},
	}),
);
